import { formatCurrency } from '@/common/utils/formatters'

export const proposalMetric = (
  isDateMetric: boolean,
  proposal: { total?: number; estimatedCompletionDate?: string },
) => (isDateMetric ? proposal.estimatedCompletionDate ?? '—' : formatCurrency(proposal.total ?? 0))
